import React from 'react';

import { Bookmark, BookmarkProps } from '@lumapps/bookmarks/components/Bookmarks/Bookmark/Bookmark';

type CustomizationBookmarkProps = BookmarkProps | { bookmarks: BookmarkProps[] };

/**
 * Customization bookmark that wraps the Bookmark component.
 * Accepts either a single flat bookmark (title/link/icon) or a `bookmarks` array to render several at once.
 * @param props - CustomizationBookmarkProps
 * @returns CustomizationBookmark
 */
export const CustomizationBookmark: React.FC<CustomizationBookmarkProps> = (props) => {
    if ('bookmarks' in props) {
        const { bookmarks } = props;

        if (!Array.isArray(bookmarks)) {
            // eslint-disable-next-line no-console
            console.warn('CustomizationBookmark: `bookmarks` prop must be an array, got', bookmarks);
            return null;
        }

        return (
            <>
                {bookmarks.map((bookmark, index) => (
                    <Bookmark key={bookmark.id ?? index} {...bookmark} />
                ))}
            </>
        );
    }

    return <Bookmark {...props} />;
};

CustomizationBookmark.displayName = 'CustomizationBookmark';
